export default __webpack_public_path__ + "static/media/thesis_client.7600a698.png";